import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const customRoutes = [
  { method: "GET", path: "/expiring", handlerName: "getExpiring" },
  { method: "GET", path: "/by-client/:clientId", handlerName: "getByClient" },
  { method: "GET", path: "/by-caregiver/:caregiverId", handlerName: "getByCaregiver" },
  { method: "POST", path: "/upload", handlerName: "upload" },
];

const baseService = createCrudService("documents", customRoutes, router);

export const documentsService = {
  ...baseService,
  getByAuthAndMonth: (authorizationId, month, year) =>
    api.getCall(`/api/documents/by-auth-month/${authorizationId}/${month}/${year}`),
  uploadClient: (formData) =>
    api.postFormDataCall('/api/documents/client/upload', formData),
  addClientLink: (data) =>
    api.postCall('/api/documents/client/link', data),
  getClientDocuments: (clientId) =>
    api.getCall(`/api/documents/client/${clientId}`),
  deleteClientDocument: (documentId) =>
    api.deleteCall(`/api/documents/client/${documentId}`),
  uploadCaregiver: (formData) =>
    api.postFormDataCall('/api/documents/caregiver/upload', formData),
  addCaregiverLink: (data) =>
    api.postCall('/api/documents/caregiver/link', data),
  getCaregiverDocuments: (caregiverId) =>
    api.getCall(`/api/documents/caregiver/${caregiverId}`),
  deleteCaregiverDocument: (documentId) =>
    api.deleteCall(`/api/documents/caregiver/${documentId}`),
  updateDocumentExpiration: (documentId, expirationDate) =>
    api.putCall(`/api/documents/client/${documentId}/expiration`, { expirationDate }),
};